// src/pages/ProfilePage.jsx
import { useState, useEffect } from "react";
import { Box, Heading, VStack, Input, Button } from "@chakra-ui/react";
import axios from "axios";
import { showSuccess, showError } from "../utils/toastUtils";

export default function ProfilePage() {
  const [form, setForm] = useState({ firstName: "", lastName: "", email: "" });

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/users/me`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => setForm(res.data))
      .catch(() => { });
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSave = async () => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/users/me`,
        form,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      showSuccess("Erfolg!", "Profil erfolgreich gespeichert.");
    } catch (err) {
      showError("Fehler!", "Profil konnte nicht gespeichert werden.");
    }
  };

  return (
    <Box p={8}>
      <Heading size="lg" mb={6}>Profil bearbeiten</Heading>
      <VStack spacing={4} align="stretch" maxW="md">
        <Input name="firstName" placeholder="Vorname" value={form.firstName} onChange={handleChange} />
        <Input name="lastName" placeholder="Nachname" value={form.lastName} onChange={handleChange} />
        <Input name="email" placeholder="E-Mail" value={form.email} onChange={handleChange} isDisabled />
        <Button colorScheme="blue" onClick={handleSave}>Speichern</Button>
      </VStack>
    </Box>
  );
}